export const isFormsOnly = () => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'forms.womsys.nl';
};
export const isServicedesk = () => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'servicedesk.womsys.nl';
};
export const productName = () =>
  isServicedesk() ? 'WOMsys Servicedesk' : (isFormsOnly() ? 'WOMsys Forms' : 'WOMsys');
